import { NavPermissions } from './nav-item';

const NO_PERMISSIONS: NavPermissions = {
  read: false,
  write: false,
  update: false,
  delete: false,
};

/**
 * Parses the legacy permission string into a typed `NavPermissions` object.
 *
 * Wire format: a 4-character string where each character is "1" (granted) or
 * "0" (denied), in the order read|write|update|delete. Mirrors the legacy
 * `splitIntoArray` helper in `fb-shipper-frontend/src/app/services/index.util.service.js`
 * (lines 760-766).
 *
 * For backwards compatibility we also tolerate the pipe-delimited form
 * ("1|0|0|0") in case a different backend version sends it that way.
 *
 * Examples:
 *   "1000"   → { read: true, write: false, ... }
 *   "1111"   → all true
 *   "1|0|0|0"→ { read: true, write: false, ... }
 *   ""       → all false
 *   undefined→ all false
 */
export function parsePermissions(raw: string | null | undefined): NavPermissions {
  if (!raw) return NO_PERMISSIONS;

  const slots = raw.includes('|') ? raw.split('|') : Array.from(raw);
  return {
    read: slots[0] === '1',
    write: slots[1] === '1',
    update: slots[2] === '1',
    delete: slots[3] === '1',
  };
}
